import React from 'react';
import ChatPerson from 'assets/images/notFounds/chatPerson.svg';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from 'context/authContext';
const ProfileInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isFarm = location.pathname.includes('farm');
  const {user} = useAuth();

  return (
    <button
      className="flex items-center justify-between w-full "
      onClick={() =>
        navigate(`/${isFarm ? 'farm' : 'wholesaler'}/profile/edit`)
      }
    >
      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center">
          <img
            src={user?.profile?.profile_image || ChatPerson}
            alt="user_profile"
            className="w-[67px] h-[67px] rounded-full"
          />
        </div>
        <div className="flex flex-col justify-start">
          <p className="font-normal text-[16px] leading-[24px] text-gray-6 text-start">
            {user?.profile?.name}
          </p>
          <span className="text-gray-5 font-normal text-[14px] leading-[24px] text-start">
            {user?.profile?.phone_number}
          </span>
        </div>
      </div>

      <div className="icon-arrow_right text-[18px] " />
    </button>
  );
};

export default ProfileInfo;
